import { defineMessages } from "react-intl";

const messages = defineMessages({
    loading: {
        id: "general.loading",
    },
    unknown: {
        id: "general.unknown",
    },
    notFound: {
        id: "error.404.title",
    },
    enterName: {
        id: "join.enterName",
    },
    name: {
        id: "join.name",
    },
    submitName: {
        id: "homework.enterName.submit",
    },
    turnDevice: {
        id: "join.turnDevice",
    },
    toFullScreen: {
        id: "join.toFullScreen",
    },
    fullScreenButton: {
        id: "join.toFullScreen.button",
    },
    homeworkDone: {
        id: "homework.done.message",
    },
    homework: {
        id: "homework",
    },
    homeworkDescription: {
        id: "homework.description.studentSide",
    },
    retry: {
        id: "error.retry",
    },
    giveUp: {
        id: "homework.giveUp",
    },
    cancel: {
        id: "general.cancel",
    },
    confirmGiveUpTitle: {
        id: "homework.giveUp.confirmTitle",
    },
    privacyNote: {
        id: "homework.privacyNote",
    },
    privacy: {
        id: "privacy.title",
    },
});

export default messages;
